import { get, post, put, destroy } from './../Config/config';
import axios from "axios";


const googleInstance = axios.create({
    baseURL: 'https://oauth2.googleapis.com'
});
googleInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('google-token-code')}`;
// SECURITY: An OAuth client_secret must never live in frontend code — anything
// here is bundled into the browser and readable by any user. These values are
// now sourced from env, but the proper fix is to perform the token exchange on
// the backend so the secret is never shipped to the client at all.
let data = {
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
    redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
    code : localStorage.getItem('google-token-code'),
    grant_type:'authorization_code'
}
export const Auth = {
    login: (data) => post('/user-auth/login', data),
    register: (id) => get(`/login/${id}`),
    me: () => get(`/users/me`),
    sendOtp: (data) => post(`forgot-password`, data),
    verifyNewPassword: (data) => post(`forgot-password-save`, data),
    registerToken: (data) => post('register-token',data),
    verifyOTP:(data)=>post('/user-auth/verify',data),

    getCalenderList: () => googleInstance.get('/calendar/v3/users/me/calendarList'),
    getAccessTokens: () => googleInstance.post('/token',data)
}

